import { mergeAttributes } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { Image as ImageComponent } from './Image';
const NAME = 'async-image';
export const AsyncImage = Image.extend({
    name: NAME,
    addAttributes() {
        var _a;
        return {
            ...(_a = this.parent) === null || _a === void 0 ? void 0 : _a.call(this),
            'data-type': {
                default: 'image',
            },
            id: {
                default: null,
                rendered: false,
            },
            loading: {
                default: null,
                rendered: false,
            },
            sizes: {
                default: 'medium',
                rendered: false,
            },
            app: {
                default: undefined,
                rendered: false,
            },
        };
    },
    addCommands() {
        return {
            setImage: options => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options,
                });
            },
            setImageAttributes: attributes => ({ commands }) => commands.updateAttributes(NAME, attributes),
        };
    },
    parseHTML: () => [
        {
            tag: 'img[src]',
            getAttrs: dom => {
                if (typeof dom === 'string')
                    return {};
                const element = dom;
                return {
                    id: element.getAttribute('data-id'),
                    app: element.getAttribute('data-app'),
                    src: element.getAttribute('src'),
                    title: element.getAttribute('title'),
                    alt: element.getAttribute('alt'),
                };
            },
        },
    ],
    renderHTML({ node, HTMLAttributes }) {
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { size, loading, id, app } = node.attrs;
        const type = 'image';
        HTMLAttributes['data-id'] = id;
        HTMLAttributes['data-type'] = type;
        HTMLAttributes['data-app'] = app;
        return [
            'figure',
            {
                'data-type': type,
                'data-id': id,
                'data-app': app,
            },
            ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)],
        ];
    },
    addNodeView() {
        return ReactNodeViewRenderer(ImageComponent);
    },
});
//# sourceMappingURL=index.js.map